module.exports = __webpack_public_path__ + "img/honor.11762821.png";